<template>
  <transition name="modal-fade">
    <div class="lower-header container modal">
      <SearchForm v-on:search-term-update="searchTermUpdate" />
      <MainMenu v-on:show-modal="showModal" />

      <div
        class="lower-caption edged-centered-space-evenly-flexbox make-flex-start hidden-on-desktop responsive-currency-container"
      >
        <RegionDropdown class="region-dropdown" />
        <CurrencyConvertor />
      </div>
    </div>
  </transition>
</template>

<script>
import SearchIcon from '../atoms/SearchIcon.vue'
import IconBase from '../atoms/IconBase.vue'
import MainMenu from './MainMenu.vue'
import CurrencyConvertor from './CurrencyConvertor.vue'
import SearchForm from './SearchForm.vue'
import RegionDropdown from './RegionDropdown.vue'

export default {
  components: {
    IconBase,
    SearchIcon,
    MainMenu,
    SearchForm,
    CurrencyConvertor,
    RegionDropdown,
  },
  data() {
    return {
      query: '',
    }
  },
  name: 'modal',
  methods: {
    close() {
      this.$emit('close')
    },
    searchTermUpdate: function(term) {
      this.query = term
    },
    showModal() {
      this.$emit('show-modal', false)
    },
  },
}
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}
</style>
